import React, { useState } from 'react';
import { Compass, Volume2, Copy, Check } from 'lucide-react';

export const BrailleModule: React.FC = () => {
  const [text, setText] = useState('AbilityOS Assistive Technology');
  const [copied, setCopied] = useState(false);

  // Simple English to Braille Cell Converter Map
  const brailleMap: Record<string, string> = {
    a: '⠁', b: '⠃', c: '⠉', d: '⠙', e: '⠑', f: '⠋', g: '⠛', h: '⠟', i: '⠊', j: '⠚',
    k: '⠅', l: '⠇', m: '⠍', n: '⠝', o: '⠕', p: '⠏', q: '⠟', r: '⠗', s: '⠎', t: '⠞',
    u: '⠥', v: '⠧', w: '⠺', x: '⠭', y: '⠽', z: '⠵', ' ': ' ',
  };

  const convertToBraille = (input: string) => {
    return input.toLowerCase().split('').map(char => brailleMap[char] || char).join('');
  };

  const brailleOutput = convertToBraille(text);

  const handleSpeakText = () => {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(text);
      window.speechSynthesis.speak(u);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-amber-100 text-amber-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Duxbury & BrailleBlaster Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Braille & Tactile Learning System</h2>
          <p className="text-xs text-slate-500">Grade 1 & 2 Nemeth Braille translator & refreshable Braille display simulator</p>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-xs font-bold text-slate-700 mb-1">Standard Text Input</label>
          <input
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Type text to convert to Braille..."
            className="w-full px-4 py-2.5 border border-slate-300 rounded-xl text-sm font-medium focus:ring-2 focus:ring-amber-500 focus:outline-none"
          />
        </div>

        {/* Braille Cells Output Canvas */}
        <div className="bg-slate-900 text-amber-400 p-6 rounded-xl space-y-4 shadow-inner">
          <div className="flex items-center justify-between text-xs text-slate-400">
            <span>Converted Grade 1 Braille Cell Pattern</span>
            <button 
              onClick={handleSpeakText} 
              className="flex items-center gap-1 text-amber-400 hover:underline font-bold"
            >
              <Volume2 className="w-4 h-4" />
              Listen Audio Preview
            </button>
          </div>

          <div className="text-4xl md:text-5xl font-mono tracking-widest leading-relaxed break-words bg-slate-950 p-6 rounded-lg border border-slate-800 min-h-[100px] flex items-center">
            {brailleOutput}
          </div>
        </div>
      </div>
    </div>
  );
};
